import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { Route } from '../enums/route';
import { RouteTitleNotFoundException } from '../exceptions/route-title-not-found.exception';

export abstract class RouteTitlesProviderService {
  public abstract titles(): Map<Route, string>;

  public entry(route: Route): Observable<string> {
    const entry = this.titles().get(route);

    if (isNil(entry)) {
      const key = Route[route];

      throw new RouteTitleNotFoundException(key);
    }

    return of(entry);
  }
}
